import React from "react";
import { dispatch } from "@rematch/core";
import _ from "lodash";
import LoadingComponent from "../../../../common/LoadingComponent";
import { toastr } from 'react-redux-toastr';

import {
  Input,
  Button,
  Header,
  Modal,
  Message,
  Grid,
  Dropdown
} from "semantic-ui-react";

class ShowFieldMappingScenarioInputs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isJSONValid: true,
      updatedMetaDataSchema: this.props.metaDataSchema,
      loader: false,
      selectedScenarioInputs: [],
      selectedInputValue: '',
      selectedCollection: '',
      selectedTeam: '',
      selectedMapValue: '',
      mapCollections: [],
      teamList: [],
      dummyFlag: false
    };
  }

  async componentWillMount() {
    if(this.props.selectedScenarioInput && this.props.selectedScenarioInput.collection && this.props.selectedScenarioInput.query){
      let payload = {
        "value": this.props.selectedScenarioInput.collection
      }
      await this.setSelectedCollection(null, payload);
      if(this.props.selectedScenarioInput.teamId){
        payload = {
          "value": this.props.selectedScenarioInput.teamId
        }
        this.setSelectedTeam(null, payload);
      }
      payload = {
        "value": this.props.selectedScenarioInput.query
      }
      this.setSelectedMapValue(null, payload);
    }
  }

  close = () => {
    this.props.close();
    this.clearState();
  };

  clearState = () => {
    this.setState({
      selectedInputValue: '',
      selectedCollection: '',
      selectedMapValue: '',
      mapCollections: [],
      teamList: [],
      selectedTeam: ''
    })
  }

  onChangeValue = (event, input) => {
    const newValue = event.target.value; // Get the new value from the event
    // Create a new array of scenarioInputs with the updated value
    const updatedScenarioInputs = this.state.selectedScenarioInputs.map((scenarioInput) => {
        // Check if the current input is the one being changed
        if (scenarioInput.name === input.name) {
            // Return a new object with the updated default value
            scenarioInput.default = newValue;
        }
        // Return the unchanged input
        return scenarioInput;
    });

    // Update the state with the new scenarioInputs array
    this.setState({ scenarioInputs: updatedScenarioInputs });
  };

  saveScenarioInputs = async () => {
    let payload = this.props.selectedActivityAction;
    payload.metaData.scenarioInputs = this.state.selectedScenarioInputs;
    this.props.close();
    await dispatch.lifeCycle.updateActivityActions(payload);
    toastr.success('Message', `Scenario inputs updated successfully`)
  }
  setSelectedCollection = async (e, value, context) => {
    this.setState({
      selectedMapValue: '',
      selectedTeam: '',
      mapCollections: []
    })
    let fields = [];
    this.setState({selectedCollection: value.value});
    let filteredData = this.props.entityFieldMapping.filter((fieldMapping) => {return fieldMapping.collectionName === value.value})[0];
    if(filteredData.collectionName == "suborganizations"){
      // fetch teams list
      let payload = {
        id: this.props.organizationId,
        teamlist: true
      }
      await dispatch.lifeCycle.getTeamsUnderManager(payload);
    } else {
      for(let field of filteredData.fieldMapping){
        fields.push({
          "key": Object.values(field)[0],
          "text": Object.keys(field)[0],
          "value": Object.values(field)[0],
        })
      }
      this.setState({mapCollections: fields})
    }
  }
  setSelectedTeam = async (e, value, context) => {
    this.setState({selectedTeam: value.value});
    let filteredData = this.props.entityFieldMapping.filter((fieldMapping) => {return fieldMapping.collectionName === this.state.selectedCollection})[0];
    let fields = [];
    for(let field of filteredData.fieldMapping){
      fields.push({
        "key": Object.values(field)[0],
        "text": Object.keys(field)[0],
        "value": Object.values(field)[0],
      })
    }
    this.setState({mapCollections: fields})
  }
  setSelectedMapValue = async (e, value, context) => {
    this.setState({selectedMapValue: value.value});
  }
  saveFieldMapping = async () => {
    let selectedScenarioInput = this.state.selectedScenarioInput;
    selectedScenarioInput.collection = this.state.selectedCollection;
    selectedScenarioInput.query = this.state.selectedMapValue;
    if(this.state.selectedCollection.length>0 && this.state.selectedCollection == 'suborganizations'){
      selectedScenarioInput.teamId = this.state.selectedTeam
    }
    this.setState({"selectedScenarioInput": selectedScenarioInput});
    this.close();
  }
  calculateModalSize = () => {
    if(this.state.selectedCollection && this.state.selectedCollection.length>0 && this.state.selectedCollection == 'suborganizations') {
      return 'fullscreen';
    } else {
      return 'large';
    }
  };
  setGridColumn = () => {
    if(this.state.selectedCollection && this.state.selectedCollection.length>0 && this.state.selectedCollection == 'suborganizations') {
      return 3;
    } else {
      return 4;
    }
  }
  render() {
    this.state.selectedScenarioInputs = this.props.selectedScenarioInputs;
    this.state.selectedScenarioInput = this.props.selectedScenarioInput;
    this.state.teamList = this.props.teamList;
    return (
      <div>
  <Modal
    open={this.props.open}
    onClose={this.close}
    size={this.calculateModalSize()} // Dynamically adjust modal size
    closeOnEscape={false}
    closeOnDimmerClick={false}
  >
    <Header content={`Scenario Input Field Mapping`} />
    <Modal.Content style={{ padding: "0.5rem" }}>
      {this.props.selectedScenarioInput ? (
        <Grid>
          {/* Header Row */}
          <Grid.Row style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
            <Grid.Column width={this.setGridColumn()}>
              <div className="acc-header">Input</div>
            </Grid.Column>
            <Grid.Column width={this.setGridColumn()}>
              <div className="acc-header">Collection</div>
            </Grid.Column>
            {this.state.teamList && this.state.teamList.length > 0 &&  this.state.selectedCollection && this.state.selectedCollection.length>0 && this.state.selectedCollection == 'suborganizations' && (
              <Grid.Column width={this.setGridColumn()}>
                <div className="acc-header">Teams</div>
              </Grid.Column>
            )}
            <Grid.Column width={this.setGridColumn()}>
              <div className="acc-header">Value</div>
            </Grid.Column>
            <Grid.Column width={this.setGridColumn()}>
              <div className="acc-header">Query</div>
            </Grid.Column>
          </Grid.Row>

          {/* Input Row */}
          <Grid.Row
            style={{
              marginBottom: "5px",
              paddingTop: "0.5rem",
              paddingBottom: "0.5rem",
            }}
          >
            <Grid.Column width={this.setGridColumn()}>
              <Input
                style={{ width: "200px", pointerEvents: "none" }}
                disabled
                placeholder="Name"
                value={this.props.selectedScenarioInput.name}
              />
            </Grid.Column>
            {this.props.entities.length > 0 && (
              <Grid.Column width={this.setGridColumn()}>
                <Dropdown
                  required
                  name="default"
                  selection
                  fluid
                  options={this.props.entities}
                  value={this.state.selectedCollection}
                  placeholder="Select Collection"
                  upward={false}
                  onChange={(e, value) => this.setSelectedCollection(e, value)}
                />
              </Grid.Column>
            )}
            {this.state.teamList && this.state.teamList.length > 0 &&  this.state.selectedCollection && this.state.selectedCollection.length>0 && this.state.selectedCollection == 'suborganizations' && (
              <Grid.Column width={this.setGridColumn()}>
                <Dropdown
                  required
                  name="default"
                  selection
                  fluid
                  options={this.state.teamList}
                  value={this.state.selectedTeam}
                  placeholder="Select Team"
                  upward={false}
                  onChange={(e, value) => this.setSelectedTeam(e, value)}
                />
              </Grid.Column>
            )}
            <Grid.Column width={this.setGridColumn()}>
              <Dropdown
                required
                name="default"
                selection
                fluid
                options={this.state.mapCollections}
                value={this.state.selectedMapValue}
                placeholder="Select Value"
                upward={false}
                onChange={(e, value) => this.setSelectedMapValue(e, value)}
              />
            </Grid.Column>
            <Grid.Column width={this.setGridColumn()}>
              <Input
                style={{ width: "200px", pointerEvents: "none" }}
                disabled
                placeholder="Database Query"
                value={this.state.selectedMapValue}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      ) : (
        "No scenario input field mapping is available"
      )}
    </Modal.Content>
    <Modal.Actions>
      <Button className="button-cancel" id="cancelSchema" onClick={this.close}>
        Close
      </Button>
      <Button
        className="button-submit"
        id="saveSchema"
        onClick={this.saveFieldMapping}
      >
        Save
      </Button>
    </Modal.Actions>
  </Modal>
      </div>
    );
  }
}

export default ShowFieldMappingScenarioInputs;
